import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {NotificationsService} from 'angular2-notifications';
import {EventsService} from "app/lib/EventsService";
import {getAdminMenuTree} from "app/lib/lib";
import {HttpClient} from "@angular/common/http";
import dictionary from "dict/static.json";
import {AuthService} from "../auth.service";
import { NavigationEnd, Router } from "@angular/router";
import {Title} from "@angular/platform-browser";

interface IMenuItemNode {
	isHidden: boolean;
	childs: IMenuItemNode[];
	route?: string;
	url?: string;
	i18n: string;
	target?: string;
}

@Component({
	selector: 'nav_menu',
	templateUrl: 'menu.component.html'
})
export class MenuComponent implements OnInit {
	public navbarCollapsed = true;
	
	public options = {
		position        : ["bottom", "right"],
		timeOut         : 3000,
		lastOnBottom    : true,
		showProgressBar : false,
	};
	
	nodes: IMenuItemNode[] = [];
	bridgeMap: { [key: string]: string } = {};
	aclResouceMap: { [key: string]: string } = {};

	currentMenuItem = '';
	
	private cotainerFluidMap: { [ key: string]: boolean } = {
		'/accessor': true,
		'/operation_data': true,
		'/perfomance': true,
		'/admin/promopult': true,
		'/billing/zero_day': true,
	};
	
	constructor(
		public cdRef: ChangeDetectorRef,
		public service: NotificationsService,
		public eventsService: EventsService,
		public http: HttpClient,
		public authService: AuthService,
		public router: Router,
		public titleService: Title,
	) {
		const me = this;

		me.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				me.currentMenuItem = event.url.replace(/^\//, '/').split('?')[0];
			}
		});
		
		// // Если несколько ajax-запросов запущено и они попадали - покажется только одно сообщение об ошибке
		this.eventsService.on('http-error', function (error) {
			me.service.error(error, null, {
				preventDuplicates : true,
			});
			
			console.error('http-error', error);
		});
		
		this.eventsService.on('error', function (error) {
			me.service.error(error, null, {
				preventDuplicates : true,
			});

			console.error('error', error);
		});
		
		this.eventsService.on('info', function (text) {
			me.service.info(text, null, {
				preventDuplicates : true,
			});
		});
	}
	
	
	async ngOnInit() {
		
		// Редирект с не ангуляровских фильтров
		if (window.location.href.indexOf('#/') != -1) {
			window.location.replace(window.location.href.replace('#/', ''));
		}
		
		this.bridgeMap = dictionary.bridgeMap;
		this.aclResouceMap = dictionary.aclResouceMap;
		
		this.nodes = getAdminMenuTree();
	}
	
	
	getContainerClass(): string {
		const routeName = this.router.routerState.snapshot.url.split('?')[0];
		return this.cotainerFluidMap[routeName] ? 'container-fluid' : 'container';
	}
	
	isAllow(node: IMenuItemNode): boolean {
		if (this.authService.isProvider && ! node.route) {
			return false;
		}
		
		if (node.route) {
			const resourceName = this.aclResouceMap[node.route];
			
			return resourceName && this.authService.isAllowResource(resourceName);
		}
		
		return !!node.url;
	}


	isAnyChildrenAllow(node: IMenuItemNode) {
		if ( ! this.authService.isProvider && (node.route === 'WL' || node.route === 'uKitAlt')) {
			return true;
		}
		
		return node.childs.some(c => this.isAllow(c));
	}

	async onSignOut() {
		await this.authService.signOut().toPromise();

		await this.router.navigate(['/sign_in']);
	}
}
